/* i18n-scan-ignore-file: es el catalogo de ApexCharts en espanol; el ingles va integrado en la libreria */
import {ApexOptions} from 'apexcharts'

// Reformats a backend period key into a locale-aware axis label.
// period is 'YYYY-MM' (month granularity) or 'YYYY-MM-DD' (day granularity).
export const formatPeriodLabel = (period: string, locale: string): string => {
  if (!period) return period
  if (period.length > 7) {
    const date = new Date(`${period}T00:00:00`)
    return new Intl.DateTimeFormat(locale, {day: 'numeric', month: 'short'}).format(date)
  }
  const date = new Date(`${period}-01T00:00:00`)
  return new Intl.DateTimeFormat(locale, {month: 'short', year: 'numeric'}).format(date)
}

// Spanish locale for the ApexCharts toolbar / export menu (English is built-in).
const apexEsLocale = {
  name: 'es',
  options: {
    months: [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
    ],
    shortMonths: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
    days: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
    shortDays: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
    toolbar: {
      exportToSVG: 'Descargar SVG',
      exportToPNG: 'Descargar PNG',
      exportToCSV: 'Descargar CSV',
      menu: 'Menú',
      selection: 'Selección',
      selectionZoom: 'Zoom de selección',
      zoomIn: 'Acercar',
      zoomOut: 'Alejar',
      pan: 'Desplazamiento',
      reset: 'Restablecer zoom',
    },
  },
}

// Returns the ApexCharts locale config for the active app locale.
// English is built into ApexCharts, so we only inject the Spanish locale when needed.
export const getApexLocaleOptions = (locale: string): Partial<ApexOptions['chart']> =>
  locale === 'es' ? {defaultLocale: 'es', locales: [apexEsLocale]} : {}
